import { render, staticRenderFns } from "./IconTranslate.vue?vue&type=template&id=3e421179&"
import script from "./IconTranslate.vue?vue&type=script&lang=js&"
export * from "./IconTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports